module.exports = __webpack_public_path__ + "img/text05.abb84c6e.svg";